import styled from '@app/styled';
import { withLinkStyle } from '@app/styles';
import { color, spacing, typography } from '@app/theme';
import { Editable } from '@lokalise/louis';

export const ToggleAllWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    margin-bottom: ${spacing(4)};
`;

export const ToggleAllLabel = styled.span`
    ${typography('custom.descriptionMedium')}
`;

export const List = styled.ul`
    display: flex;
    align-items: center;
    flex-direction: column;
    margin: 0;
    padding: 0;
    list-style-type: none;
`;

export const Item = styled.li`
    display: flex;
    align-items: center;
    flex: 1;
    border-style: solid;
    border-color: ${color('border.light')};
    border-width: 0;
    border-top-width: 1px;
    width: 100%;
    padding-top: ${spacing(2)};
    padding-bottom: ${spacing(2)};
`;

export const Language = styled.span`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex: 1;
    ${typography('custom.description')}
`;

export const LanguageIconWrap = styled.span`
    margin-left: ${spacing(2)};
    display: inline-flex;
`;

export const LanguageName = styled.span`
    margin-left: ${spacing(2)};
`;

export const LanguageInfo = styled.span`
    ${withLinkStyle}
    margin-left: ${spacing(1)};
`;

export const ProgressWrap = styled.span`
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    flex: 1;
`;

export const Percentage = styled.span`
    display: flex;
    flex-shrink: 0;
    width: 40px;
`;

export const ProgressBarWrap = styled.span`
    width: 100%;
    margin-left: ${spacing(4)};
`;

export const ToggleWrap = styled.div`
    position: relative;
`;

export const FadeoutSection = styled.div`
    position: absolute;
    bottom: 35px;
    left: 0;
    height: 40px;
    width: 100%;
    background: linear-gradient(180deg, rgba(249, 249, 249, 0) 0%, ${color('background.surface.middle')} 100%);
`;

export const LanguageInfoEditable = styled(Editable)`
    width: auto;
`;
